import { InjectionToken } from '@angular/core';
import { IHeader } from '@effy-tech/acquisition-core/header';
import { EffySite } from '@effy-tech/angular-common/site';
import { EnvironmentModel } from '../../interfaces/environment.interface';

export const ENVIRONMENT_DATA = new InjectionToken<EnvironmentModel>('ENVIRONMENT_DATA');
export const HEADER_DATA = new InjectionToken<IHeader>('HEADER_DATA');
export const SITE = new InjectionToken<EffySite>('SITE');
